module.exports = __webpack_public_path__ + "fonts/fa-solid-900.6832e004.woff2";